import { CardsPokemon } from "../../components/pokemon-cards"
import { BtnTopBot } from "../../components/btn-top-bot"
import { Footer } from "../../components/footer"

export const Home = () => (
    <>
        <CardsPokemon />
        <BtnTopBot />
        <Footer />
    </>
)